import { Component } from "react";
import withAuth from "../../../components/withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import AnalyseRisquesStatusTimeLine from "../../../components/AnalyseRisques/AnalyseRisquesStatusTimeLine";
import FormControl from "@mui/material/FormControl";
import {
	setHeader,
	getAffair,
	getWorkOrder,
	buildOpenErpCode,
} from "../../../redux/analyseRisques/analyseRisquesActions";
import { clone } from "../../../utils";
import { TYPING_TIMEOUT } from "../../../constants";
import CustomizedTextField from "../../../components/Input/CustomizedTextField";
import TextFieldWithTypingTimeout from '../../../components/Input/TextFieldWithTypingTimeout';
import { InputLabel } from "@mui/material";
import CustomizedSelect from "../../../components/Input/CustomizedSelect";

class AnalyseRisquesHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			numOt: props.header.ot ? props.header.ot.name : props.header.numOt ? props.header.numOt : "",
			affair: props.header.affair ? props.header.affair.code : props.header.affairInput,
			contactInput: props.header.customer_contact_tablet,
			customer: props.header.customer,
			timeout: TYPING_TIMEOUT,
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let modifiedState = prevState;

		if (prevState.affair !== nextProps.header.affairInput) modifiedState.affair = nextProps.header.affairInput;

		if (prevState.numOt !== nextProps.header.numOt) modifiedState.numOt = nextProps.header.numOt;

		return modifiedState;
	}

    onNumOtChange(value) {
        const header = clone(this.props.analyseRisques.header);
        header.numOt = value;
        this.props.getWorkOrder(value, header, this.props.activeUser.id);
    }

    onAffairChange(event) {
		let value = event.target.value;
        const header = clone(this.props.analyseRisques.header);
        header.affairInput = value;
        this.props.getAffair(value, header, this.props.activeUser.id);
    }

    onContactChange(event) {
        let value = event.target.value;

        const header = clone(this.props.header);
        header.contact = value;
        this.props.setHeader(header);
    }

    onContactInputChange(event) {
        const header = clone(this.props.header);
        header.customer_contact_tablet = event.target.value;
        this.props.setHeader(header);
    }

	onDeliveryAddressChange(event) {
		let value = event.target.value;

		const header = clone(this.props.header);
		header.delivery_address = value;
		this.props.setHeader(header);
	}

	render() {
		let customer = null;
		if (this.props.header.ot && this.props.header.ot.customer) customer = this.props.header.ot.customer;
		else if (this.props.header.affair && this.props.header.affair.customer)
			customer = this.props.header.affair.customer;

		let contact = null;
		if (customer && customer.contacts) contact = customer.contacts.find((c) => c.id === this.props.header.contact);

		let contactPhone = "";
		if (contact && contact.mobile) contactPhone = contact.mobile;
		else if (contact && contact.phone) contactPhone = contact.phone;

		let code;

		if (this.props.header.id) code = buildOpenErpCode(this.props.header.id);
		else code = "/";

		let contactsElement = [];

		if (customer && customer.contacts) {
			contactsElement.push(<MenuItem key="-1" value={""} />);

			contactsElement = contactsElement.concat(
				customer.contacts.map((c) => (
					<MenuItem key={c.id} value={c.id}>
						{c.name}
					</MenuItem>
				))
			);
		}

		return (
			<div className="row full-height">
				<div className="col-lg-6 col-md-6 col-sm-6 col-12 without-side-padding">
					<CustomizedTextField
						key="code"
						id="code"
						label={"Code"}
						className="full_size"
						inputProps={{ maxLength: 8 }}
						disabled
						value={code}
					/>
				</div>
				<div className="offset-lg-2 col-lg-4 offset-md-2 col-md-4 col-sm-6 col-12">
					<AnalyseRisquesStatusTimeLine currentStatus={this.props.header.status} />
				</div>
				<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding row fieldset">
					<div className="col-lg-5 col-md-5 col-sm-12 col-12 control-margin-top">
                        <TextFieldWithTypingTimeout
							key="numOt"
                            id="numOt"
                            label={"Numéro OT"}
                            className="full_size"
                            inputProps={{ maxLength: 8 }}
                            value={this.state.numOt}
                            onValueChange={this.onNumOtChange.bind(this)}
                            />
					</div>
					<div className="col-lg-2 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4 div-center control-margin-top">
						<span className="span-center">OU</span>
					</div>
					<div className="col-lg-5 col-md-5 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="affair"
							key="affair"
							label={"Affaire"}
							className="full_size"
							value={this.state.affair}
							onChange={this.onAffairChange.bind(this)}
						/>
					</div>
				</div>
				<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding row fieldset">
					<div className="col-lg-5 col-md-5 col-sm-12 col-12 control-margin-top">
						<FormControl className="col-lg-12 col-md-12 col-sm-12 col-12">
							<InputLabel id="contact-label">Contact E.U.</InputLabel>
							<CustomizedSelect
								labelId="contact-label"
								id="contact"
								label="Contact E.U."
								value={
									this.props.header.contact && this.props.header.contact
										? this.props.header.contact
										: ""
								}
								onChange={this.onContactChange.bind(this)}
								className="full_size"
							>
								{contactsElement}
							</CustomizedSelect>
						</FormControl>
					</div>
					<div className="col-lg-2 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4 div-center control-margin-top">
						<span className="span-center">OU</span>
					</div>
					<div className="col-lg-5 col-md-5 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="contact-input"
							key="contact-input"
							label={"Nouveau contact"}
							className="full_size"
                            value={this.props.header.contactInput}
							onChange={this.onContactInputChange.bind(this)}
						/>
					</div>
				</div>
				<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top without-side-padding">
					<FormControl className="col-lg-12 col-md-12 col-sm-12 col-12">
						<InputLabel id="delivery-address-label">{"Site d'intervention"}</InputLabel>
						<CustomizedSelect
							labelId="delivery-address-label"
							id="delivery-address"
							label="Site d'intervention"
							value={
								this.props.header.delivery_address && this.props.header.delivery_address
									? this.props.header.delivery_address
									: ""
							}
							onChange={this.onDeliveryAddressChange.bind(this)}
							className="full_size"
						>
							{customer && customer.delivery_addresses
								? customer.delivery_addresses.map((c) => (
										<MenuItem key={c.id} value={c.id}>
											{c.name}
										</MenuItem>
								  ))
								: ""}
						</CustomizedSelect>
					</FormControl>
				</div>
				<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top without-side-padding">
					<CustomizedTextField
						id="company"
						label={"Agence"}
						className="full_size"
						disabled
						value={
							this.props.header.affair && this.props.header.affair.company_id
								? this.props.header.affair.company_id[1]
								: ""
						}
					/>
				</div>
				<div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="customer"
							label={"Client"}
							disabled
							className="full_size"
							value={customer ? customer.name : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="address"
							label={"Adresse"}
							disabled
							className="full_size"
							value={customer && customer.street ? customer.street : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="additionnal-address"
							label={"Complément d'adresse"}
							disabled
							className="full_size"
							value={customer && customer.street2 ? customer.street2 : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="zip-code"
							label={"Code postal"}
							disabled
							className="full_size"
							value={customer && customer.zip ? customer.zip : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="city"
							label={"Ville"}
							disabled
							className="full_size"
							value={customer && customer.city ? customer.city : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="country"
							label={"Pays"}
							disabled
							className="full_size"
							value={
								customer && customer.country_id && customer.country_id[1] ? customer.country_id[1] : ""
							}
						/>
					</div>
				</div>
				<div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="phone"
							label={"Téléphone"}
							disabled
							className="full_size"
							value={customer && customer.phone ? customer.phone : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="mobile"
							label={"Portable"}
							disabled
							className="full_size"
							value={customer && customer.mobile ? customer.mobile : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="fax"
							label={"Fax"}
							disabled
							className="full_size"
							value={customer && customer.fax ? customer.fax : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="mail"
							label={"Email"}
							disabled
							className="full_size"
							value={customer && customer.email ? customer.email : ""}
						/>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="phone-contact"
							label={"E.U. phone"}
							disabled
							className="full_size"
							value={contactPhone}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		header: state.analyseRisques.header,
		analyseRisques: state.analyseRisques,
		companies: state.companies.companies,
		analysesRisques: state.analysesRisques,
		activeUser: state.activeUser,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setHeader: (header) => dispatch(setHeader(header)),
		getAffair: (code, header, userId) => dispatch(getAffair(code, header, userId)),
		getWorkOrder: (code, header, userId) => dispatch(getWorkOrder(code, header, userId)),
	};
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesHeader);
